export const CommitsRoutePath = '/:owner/:repo/pull/:pr_number/commits'
export const FilesRoutePath = '/:owner/:repo/pull/:pr_number/files'
export const ChangesRoutePath = '/:owner/:repo/pull/:pr_number/changes'
export const ChangesWithRangeRoutePath = '/:owner/:repo/pull/:pr_number/changes/:range'
